var $38c4aa5b1c9b03cc$exports = {};
$38c4aa5b1c9b03cc$exports = {
    "clear": `Vymazat`,
    "invalid": `(neplatn\xe9)`,
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "noResults": `\u{17D}\xe1dn\xe9 v\xfdsledky`,
    "valid": `(platn\xe9)`
};


export {$38c4aa5b1c9b03cc$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
